import { useEffect } from 'react';
import { useData } from '@hooks/useData';
import { GetAllSettingsSuccessResponse } from '@services/useGetAllSettings';

const applySettingsToCSS = (settings: GetAllSettingsSuccessResponse['data']) => {
    const root = document.documentElement;

    if (settings?.layouts) {
        const findValue = (name: string) => settings?.layouts?.find((item) => item.name === name)?.value;

        root.style.setProperty('--background-website-color', findValue('primary color') || '#000');
        root.style.setProperty('--background-website-secondary-color', findValue('secondary color') || '#000');
        root.style.setProperty('--buttons-color', findValue('buttons color') || '#000');
        root.style.setProperty('--titles-color', findValue('titles color') || '#000');
        root.style.setProperty('--subtitles-color', findValue('subtitles color') || '#000');
        root.style.setProperty('--website-font-type', findValue('fontType') || 'sans-serif');

        /* cspell:disable */
        const fontFamily = findValue('fontfamily') || 'Mulish';
        root.style.setProperty('--website-font-family', fontFamily);
        const fontURL =
            fontFamily.toLowerCase() === 'mulish'
                ? `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s+/g, '+')}:ital,wght@0,200..1000;1,200..1000&display=swap`
                : `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s+/g, '+')}&display=swap`;
        /* cspell:enable */
        if (!document.querySelector(`link[href="${fontURL}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = fontURL;
            document.head.appendChild(link);
        }
    }
};

export const GlobalStylesUpdater = () => {
    const { allSettings } = useData();

    useEffect(() => {
        if (allSettings?.data) {
            applySettingsToCSS(allSettings.data);
        }
    }, [allSettings]);

    return null;
};
